var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 3C12.3693 3 12.7086 3.20355 12.8824 3.52941L20.8824 18.5294C21.0477 18.8393 21.0382 19.2133 20.8575 19.5145C20.6768 19.8157 20.3513 20 20 20H4C3.64874 20 3.32323 19.8157 3.14251 19.5145C2.96178 19.2133 2.95235 18.8393 3.11765 18.5294L11.1176 3.52941C11.2914 3.20355 11.6307 3 12 3ZM5.66667 18H18.3333L12 6.125L5.66667 18Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 10.051C12.4142 10.051 12.75 10.3868 12.75 10.801V13.801C12.75 14.2152 12.4142 14.551 12 14.551C11.5858 14.551 11.25 14.2152 11.25 13.801V10.801C11.25 10.3868 11.5858 10.051 12 10.051Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 16.0137C11.8619 16.0137 11.75 16.1257 11.75 16.2637C11.75 16.4018 11.8619 16.5137 12 16.5137C12.1381 16.5137 12.25 16.4018 12.25 16.2637C12.25 16.1257 12.1381 16.0137 12 16.0137ZM12 17.0137C12.4142 17.0137 12.75 16.6779 12.75 16.2637C12.75 15.8495 12.4142 15.5137 12 15.5137C11.5858 15.5137 11.25 15.8495 11.25 16.2637C11.25 16.6779 11.5858 17.0137 12 17.0137Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.ea216a01d5fd882c762854437b38a7fc.svg";
export { ForwardRef as ReactComponent };